import { render, staticRenderFns } from "./MobileIntroduction.vue?vue&type=template&id=3bb30316&scoped=true&"
import script from "./MobileIntroduction.vue?vue&type=script&lang=js&"
export * from "./MobileIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./MobileIntroduction.vue?vue&type=style&index=0&id=3bb30316&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb30316",
  null
  
)

export default component.exports